<template>
  <div class="jl-login-wrap" @keyup.enter="submit">
    <div class="login-header">
      <div class="jl-container">
        <div class="jl-login-headbox clearfix">
          <div class="item-left">
            <router-link class="jl-logo" :to="{ name: 'home' }">
              <img src="../assets/img/logo.png" alt />
            </router-link>
          </div>
          <div class="item-right">
            <div class="jl-i-r">
              <p class="text1">
                {{isLogin?'没有账号！':'已有账号！'}}
                <router-link v-if="isLogin" :to="{ name: 'register' }">立即注册</router-link>
                <router-link v-else :to="{ name: 'login' }">立即登录</router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="login-body">
      <div class="jl-container">
        <div class="login-body-content clearfix">
          <div class="body-left">
            <img src="../assets/img/zkj-login-img.jpg" alt />
          </div>
          <div class="body-right">
            <div class="body-r-box">
              <h2>{{isLogin?'用户登录':'用户注册'}}</h2>
              <div class="login-form">
                <div class="login-choose" v-if="!isLogin">
                  <el-radio v-model="registerType" label="1">手机注册</el-radio>
                  <el-radio v-model="registerType" label="2">邮箱注册</el-radio>
                </div>
                <div class="login-ground">
                  <label
                    class="label"
                    for="tel"
                  >{{isLogin?'用户账号':(registerType === "1"?'手机号码':'邮箱号码')}}:</label>
                  <input
                    class="input"
                    v-model.trim="phone"
                    type="text"
                    :placeholder="placeholderTextPhone"
                  />
                </div>
                <div class="login-ground" v-if="!isLogin">
                  <label class="label" for="tel">验证码:</label>
                  <div class="login-code">
                    <input
                      class="input"
                      v-model.trim="verifyCode"
                      type="text"
                      :placeholder="placeholderTextCode"
                    />
                    <div
                      :class="[boolCode?'code-btn active':'code-btn disabled']"
                      @click="sendCode"
                    >
                      <span>{{codeText}}</span>
                      <i class="el-icon-loading" v-if="sendCodeLoading"></i>
                    </div>
                  </div>
                </div>
                <div class="login-ground">
                  <label class="label" for="tel">账号密码:</label>
                  <div class="login-password">
                    <input
                      class="input"
                      :type="passwordText"
                      :placeholder="[isLogin?'请输入密码':'请输入密码6～16位，数字，字母组合']"
                      v-model.trim="password"
                    />
                    <div class="pass-icon" @click="isShowPassword =!isShowPassword">
                      <i :class="[isShowPassword?'jl-icon-eye active':'jl-icon-eye']"></i>
                    </div>
                  </div>
                </div>
                <div class="form-check" v-if="isLogin">
                  <input
                    id="color-input-red"
                    class="chat-button-location-radio-input"
                    type="checkbox"
                    name="color-input-red"
                    @change="rememberPassword"
                    v-model="checkValue"
                  />
                  <label for="color-input-red"></label>
                  <span class="span-check">记住密码</span>
                </div>
                <div class="login-submit">
                  <button class="btn" @click="submit">
                    {{isLogin?'立即登录':'立即注册'}}
                    <i class="el-icon-loading" v-if="isLoading"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="login-footer">
      <p class="text1">备案：沪ICP备12014369号-1 沪公网安备 31011802001543号</p>
    </div>
  </div>
</template>

<script>
import encrypt from "@/utils/encrypt";
import { login, register, getVerifyCode, getEmailVerifyCode } from "@/api/user";
export default {
  props: {
    isLogin: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isShowPassword: false,
      codeText: "获取验证码",
      boolCode: true,
      codeIntervals: 60, //验证码间隔时间发送,
      isLoading: false,
      phone: "",
      verifyCode: "",
      password: "",
      checkValue: false, //记住密码,
      selectOption: [1, 2, 3, 4, 5],
      registerType: "1",
      sendCodeLoading: false
    };
  },
  watch: {
    registerType(n, o) {
      //切换注册方式，初始化数据
      this.codeText = "获取验证码";
      this.phone = "";
      this.verifyCode = "";
      this.password = "";
      this.boolCode = true;
      this.codeIntervals = 60;
      clearTimeout(this.st);
      this.sendCodeLoading = false;
    }
  },
  computed: {
    passwordText() {
      return this.isShowPassword ? "text" : "password";
    },
    placeholderTextPhone() {
      let text = "";
      if (this.isLogin) {
        text = "请输入手机号或者邮箱号";
      } else {
        text = this.registerType === "1" ? "请输入手机号" : "请输入邮箱号码";
      }
      return text;
    },
    placeholderTextCode() {
      return this.registerType === "1"
        ? "请输入短信验证码"
        : "请输入邮箱验证码";
    }
  },
  created() {
    this.rememberLogin();
  },
  methods: {
    //发生验证码
    sendCode() {
      if (!this.boolCode) return;
      let text = null;

      if (!this.phone) {
        if (this.registerType === "1") {
          text = "请输入手机号";
        } else {
          text = "请输入邮箱号";
        }
        this.tips(text);
        return;
      }
      let regPhone = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/,
        regEmail = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      if (
        !regPhone.test(this.phone) &&
        !this.isLogin &&
        this.registerType === "1"
      ) {
        this.tips("手机号格式不正确");
        return;
      }
      if (
        !regEmail.test(this.phone) &&
        !this.isLogin &&
        this.registerType === "2"
      ) {
        this.tips("邮箱格式不正确");
        return;
      }
      this.boolCode = false;
      this.sendCodeLoading = true;
      if (this.registerType === "1") {
        getVerifyCode(this, bool => {
          this.sendCodeLoading = false;
          if (bool === true) {
            this.setTime(this.codeIntervals);
          } else {
            this.boolCode = true;
          }
        });
      } else {
        getEmailVerifyCode(this, bool => {
          this.sendCodeLoading = false;
          if (bool === true) {
            this.setTime(this.codeIntervals);
          } else {
            this.boolCode = true;
          }
        });
      }
    },
    //设置重新获取事件function
    setTime(val) {
      this.codeText = "重新获取" + "(" + val + "s)";
      if (val === -1) {
        this.codeText = "获取验证码";
        this.boolCode = true;
      } else {
        this.st = setTimeout(() => {
          this.setTime(--val);
        }, 1000);
      }
    },
    //记住密码
    rememberPassword() {
      let str = JSON.stringify({
        phone: this.phone,
        password: this.password
      });
      //对密码用户名加密
      let userLogin = encrypt.Encrypt(str);
      localStorage.setItem("userLogin", userLogin);
    },
    //解密密码登录
    rememberLogin() {
      let str = localStorage.getItem("userLogin");
      if (str && this.isLogin) {
        let obj = JSON.parse(encrypt.Decrypt(str));
        setTimeout(() => {
          this.phone = obj.phone;
          this.password = obj.password;
        }, 1000);
      }
    },
    //登录 || 注册
    submit() {
      let reg = /^(?![^a-zA-Z]+$)(?!\D+$).{6,15}$/; //密码长度为6～16位，数字，字母，字符至少含两种
      let regPhone = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
      let regEmail = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;

      if (!this.phone && this.registerType === "1") {
        this.tips("请输入手机号");
        return;
      }

      if (!this.phone && this.registerType === "2") {
        this.tips("请输入邮箱");
        return;
      }

      if (
        !regPhone.test(this.phone) &&
        !this.isLogin &&
        this.registerType === "1"
      ) {
        this.tips("手机号格式不正确");
        return;
      }
      if (
        !regEmail.test(this.phone) &&
        !this.isLogin &&
        this.registerType === "2"
      ) {
        this.tips("邮箱格式不正确");
        return;
      }

      if (!this.verifyCode && !this.isLogin) {
        this.tips("请输入验证码");
        return;
      }
      if (!this.password) {
        this.tips("请输入密码");
        return;
      }
      if (!reg.test(this.password) && !this.isLogin) {
        this.tips("密码格式不正确");
        return;
      }
      this.isLoading = true;
      if (this.isLogin) {
        login(this, res => {
          this.isLoading = false;
          if (this.checkValue) {
            this.rememberPassword();
          }
          if (res.data && res.data.frontUser) {
            let obj = res.data.frontUser;
            obj.userId = obj.id;
            this.$store.dispatch("setUserInfo", obj);
            localStorage.setItem("token", obj.token);
            if (this.$route.query.redirect) {
              this.$router.push({
                path: this.$route.query.redirect
              });
            } else {
              this.$router.push({
                name: "home"
              });
            }
          }
        });
      } else {
        register(this, res => {});
      }
    },
    //提示
    tips(text) {
      this.$notify({
        title: "提示",
        type: "warning",
        message: text
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.jl-login-wrap {
  background: url("../assets/img/zkj-login-bg.jpg") no-repeat center center;
  background-size: cover;
}
.login-header {
  border-bottom: 1px solid #e0e0e0;
}
.jl-container {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.jl-login-headbox {
  .item-left {
    float: left;
  }

  .jl-logo {
    display: block;
    line-height: 120px;
    img {
      display: inline-block;
      vertical-align: middle;
    }
  }
  .item-right {
    float: right;
    line-height: 120px;
  }
  .jl-i-r {
    display: inline-block;
    .text1 {
      font-size: 16px;
      color: #333;
      a {
        color: #e50011;
      }
    }
  }
}
.login-body {
  padding: 160px 0;
}
.login-body-content {
  padding: 20px;
  background: #fff;
  box-shadow: 0 0 29px rgba($color: #696969, $alpha: 0.2);
  .body-left {
    float: left;
    width: 61.67%;
    overflow: hidden;
    img {
      display: block;
      width: 100%;
      transition: all 0.3s;
    }
  }
  .body-right {
    float: right;
    width: 38.33%;
    .body-r-box {
      padding: 50px 50px 0 50px;
      h2 {
        font-size: 32px;
        color: #333;
        text-align: center;
        margin-bottom: 20px;
      }
    }
    .login-choose {
      margin-bottom: 20px;
    }
    .login-ground {
      border-bottom: 1px solid #e0e0e0;
      margin-bottom: 30px;
      .label {
        display: block;
        font-size: 14px;
        color: #333;
        margin-bottom: 10px;
      }
      .input {
        font-size: 14px;
        display: block;
        width: 100%;
        outline: none;
        line-height: 35px;
        height: 35px;
      }
    }
    .login-password {
      position: relative;
      .pass-icon {
        position: absolute;
        right: 0;
        top: 50%;
        display: block;
        width: 16px;
        height: 16px;
        transform: translateY(-50%);
        color: #999;
        cursor: pointer;
        i {
          color: #999;
        }
        i.active {
          color: #333;
        }
      }
    }
    .login-code {
      position: relative;
      .code-btn {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        font-size: 14px;
        color: #999;
        padding-left: 14px;
        cursor: pointer;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          width: 1px;
          height: 100%;
          background: #999;
        }
        &.active {
          color: #e50011;
        }
        &.disabled {
          cursor: not-allowed;
        }
      }
    }
  }
}
.login-submit {
  margin-top: 18px;
  .btn {
    display: block;
    width: 100%;
    border: 1px solid #e50011;
    font-size: 16px;
    color: #e50011;
    background: transparent;
    text-align: center;
    padding: 15px 0;
    outline: none;
    cursor: pointer;
    transition: all 0.3s;
  }
}

.form-check {
  position: relative;
  padding-left: 25px;
}
.span-check {
  font-size: 14px;
  color: #999;
}
#color-input-red {
  position: absolute;
  z-index: -200;
  visibility: hidden;
}
#color-input-red + label {
  display: block;
  width: 14px;
  height: 14px;
  cursor: pointer;
  position: absolute;
  top: 2px;
  left: 0;
  background: transparent;
  border: 1px solid #a8a8a8;
}
#color-input-red:checked + label {
  background: #e81727;
  border-color: #e81727;
}
#color-input-red:checked + label::before {
  content: "\2714";
  display: block;
  text-align: center;
  font-size: 12px;
  color: #fff;
}

.login-footer {
  background: #1f1f1f;
  .text1 {
    font-size: 16px;
    color: #999;
    text-align: center;
    padding: 26px 0;
  }
}

@media screen and (min-width: 1200px) {
  .login-body-content .body-left:hover img {
    transform: scale(1.1);
  }
  .login-submit .btn:hover {
    background: #e50011;
    color: #fff;
  }
}
@media screen and (max-width: 1440px) {
  .jl-login-headbox .item-right,
  .jl-login-headbox .jl-logo {
    line-height: 100px;
  }
  .login-body {
    padding: 100px 0;
  }
}
</style>

<style>
.login-choose .el-radio__input.is-checked + .el-radio__label {
  color: #e50011;
}
.login-choose .el-radio__input.is-checked .el-radio__inner {
  border-color: #e50011;
  background: #e50011;
}
.login-choose .el-radio__inner:hover {
  border-color: #e50011;
}
</style>

